import { Menu, MenuItem, Typography } from "@mui/material";
import styles from "../styles/preview.module.scss";
import { ToggleButton } from "../StoryPreview";
import { useConsole, useUser } from "contexts";
import { UserRoles } from "data/roles";
import PropTypes from "prop-types";
import { useState } from "react";
import { Icon } from "ui";

import ArchiveButton from "./ArchiveButton";
import DeleteButton from "./DeleteButton";
import FirebaseButton from "./FirebaseButton";
import VisibilityButton from "./VisibilityButton";

function MoreButton({ onClose, story }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const { screen } = useConsole();
  const open = Boolean(anchorEl);
  const { hasRole } = useUser();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    onClose();
  };

  const buttons = [
    ArchiveButton,
    FirebaseButton,
    VisibilityButton,
    DeleteButton,
  ].map((Component, index) => (
    <Component
      key={index}
      onClose={handleClose}
      story={story}
      mode={screen.isMobile ? "button" : "menu"}
    />
  ));

  if (screen.isMobile || !hasRole(UserRoles.ADMIN)) return buttons;

  return (
    <>
      <ToggleButton icon="more_vert" label="Más" onClick={handleClick} />
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            "aria-labelledby": "basic-button",
          },
        }}
      >
        {buttons}
      </Menu>
    </>
  );
}

MoreButton.propTypes = {
  onClose: PropTypes.func.isRequired,
  story: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }).isRequired,
};

export const MoreItem = ({ children, icon, onClick }) => {
  return (
    <MenuItem className={styles.menuItem} onClick={onClick}>
      {icon && <Icon name={icon} />}
      <Typography>{children}</Typography>
    </MenuItem>
  );
};

export default MoreButton;
